import React, { FunctionComponent, useState } from 'react'
import useTranslation from '../../hooks/useTranslation'
import DigitalGiveawayIcon from '../../assets/media/icons/digital-giveaway-link.svg'
import CartboxButton from '../cartbox-button'
import DigitalGiveawayModal from '../digital-giveaway-modal'

export type Props = {
    openDigitalGiveawayModal: Function
    configurationIsBuildable: boolean
}

const DigitalGiveawayButton: FunctionComponent<Props> = (props) => {
    const { openDigitalGiveawayModal, configurationIsBuildable } = props
    const { t } = useTranslation()
    const openModalState = useState(false)
    const setOpenModalState = openModalState[1]

    const clickHandler = (): void => {
        openDigitalGiveawayModal()
        setOpenModalState(true)
    }

    return (
        <>
            <CartboxButton
                onClick={clickHandler}
                disabled={!configurationIsBuildable}
                icon={<DigitalGiveawayIcon />}
                label={t(`digitalGiveaway.linkText`)}
                dataTestId="cart-button-digital-giveaway"
            />
            <DigitalGiveawayModal openModalState={openModalState} />
        </>
    )
}

export default DigitalGiveawayButton
